import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { RiFileExcel2Fill, RiFilePdfFill, RiLoader2Line } from 'react-icons/ri';
import dates from '~/utils/dates';
import numbers from '~/utils/numbers';
import './styles.css';

// // Components
import Admin from '~/components/Admin';
import Loading from '~/components/Default/Loading';
import { Cative, MercadoLivre } from '~/components/Parts/CalculatesBox';
import { useSingleReport } from './useSingle';
import { FiArrowLeft } from 'react-icons/fi';

const Report: React.FC = () => {
	const location = useLocation();
	const navState = (location.state as { reportType?: 'definitive' | 'preliminary', month?: number, year?: number } | null) || {};
	const params = useParams();
	const now = new Date();
	const currentMonth = now.getMonth() + 1;
	const currentYear = now.getFullYear();
	function deriveReportParams() {
		let m = navState.month ?? currentMonth;
		let y = navState.year ?? currentYear;
		let t: 'definitive' | 'preliminary' = navState.reportType ?? 'preliminary';
		if (params?.yearMonth && typeof params.yearMonth === 'string') {
			const [yy, mm] = params.yearMonth.split('-');
			const ymY = Number(yy);
			const ymM = Number(mm);
			if (Number.isFinite(ymY) && Number.isFinite(ymM)) {
				y = ymY;
				m = ymM;
			}
		}
		return { t, m, y };
	}
	const { t: derivedType, m: derivedMonth, y: derivedYear } = deriveReportParams();
    const {
        ready,
        unit,
        unitCalc,
        downReady,
        downPDFReady,
        exportPDF,
        exportExcel,
        typeReport,
        statusReq,
    } = useSingleReport(derivedType, derivedMonth, derivedYear);
    const navigate = useNavigate();


    function calculateEconomy(cativeEconomy: number, freeMarketEconomy:number){
        const base = (unitCalc as any)?.cativo?.totalFlag || 0;
        if (!base) return '0%';
        const result = cativeEconomy - freeMarketEconomy;
        const percentage = (result / base) * 100;
        return numbers.format(percentage, true, 2) + '%';
    }

    return (
        <Admin
            pageTitle="Relatório - Comparativo de Economia do Mercado Cativo x Mercado Livre de Energia - Clientes Serena"
            title="Relatório de Economia Cativo x Livre"
            classMain='report'>
            {
                ready ? (
                        <>
                            <div className="header">
                                <div className='title'>
                                    <div className="titleReport">
                                        <button
                                            type="button"
                                            className="back"
                                            onClick={() => navigate(-1)}
                                        >
                                            <FiArrowLeft size="20" />
                                        </button>
                                        <h1>{unit?.name || (unitCalc as any)?.data?.name || '-'}</h1>
                                        <span
                                            className={`pill pill--status ${typeReport === 'preliminary' ? 'pill--preliminary' : 'pill--definitive'}`}
                                        >
                                            {typeReport === 'preliminary' ? 'PRELIMINAR' : 'DEFINITIVO'}
                                        </span>
                                    </div>
                                    <br />
                                    <p>Esse relatório é referente ao mês de <strong>{dates._getNameMonth(derivedMonth-1)} de {derivedYear}</strong></p>
                                </div>

                                <div className="buttons">
                                    {
                                        downReady ?
                                        <button className="btnExcel" onClick={() => {exportExcel()}}>
                                            <RiFileExcel2Fill size="15" color="#FFFFFF" /> <span>Exportar Excel</span>
                                        </button> :
                                        <button className="btnLoad">
                                            <RiLoader2Line size="15" color="#FFFFFF" /> <span>Aguarde</span>
                                        </button>
                                    }

                                    {
                                        downPDFReady ?
                                        <button className="btnPDF" onClick={() => {exportPDF()}}>
                                            <RiFilePdfFill size="15" color="#FFFFFF" /> <span>Exportar PDF</span>
                                        </button> :
                                        <button className="btnLoad">
                                            <RiLoader2Line size="15" color="#FFFFFF" /> <span>Aguarde</span>
                                        </button>
                                    }
                                </div>
                            </div>

                            <div id="print">
                                {
                                    !(unitCalc as any)?.data ? (
                                        <div className="calculateBox">
                                            <div style={{ padding: 16 }}>
                                                <b>Não foi possível carregar o relatório.</b>
                                                <div style={{ marginTop: 8 }}>
                                                    Status: {statusReq ?? '-'}
                                                </div>
                                                <div style={{ marginTop: 12 }}>
                                                    <button type="button" className="back" onClick={() => navigate(-1)}>
                                                        Voltar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                <div className="headerLine">
                                    <div className="provider">
                                        <b>Distribuidora:</b> { (unitCalc as any)?.data?.provider?.name || '-' } <i>- { (unitCalc as any)?.data?.power } - { (unitCalc as any)?.data?.modality }</i>
                                    </div>
                                    <div className="typeEnergy">
                                        <b>Energia no Mercado Livre:</b> { (unitCalc as any)?.data?.type==='inc' ? 'Incentivada' : 'Convencional' }
                                    </div>
                                </div>

                                <div className="savings">
                                    <div
                                        className={
                                            `economy${(((unitCalc as any).cativo?.totalFlag ?? 0)-((unitCalc as any).mercadoLivre?.total ?? 0)) < 0 ? ' neg' : ''}`
                                        }
                                    >
                                        <div className="label">
                                            Economia com o Mercado Livre (R$)
                                        </div>
                                        <div className="value">
                                            { numbers.money(((unitCalc as any).cativo?.totalFlag ?? 0)-((unitCalc as any).mercadoLivre?.total ?? 0), false) }
                                        </div>
                                    </div>

                                    <div className={ `economy${((((unitCalc as any).cativo?.totalFlag ?? 0)-((unitCalc as any).mercadoLivre?.total ?? 0))<0) ? ' neg' : ''}` }>
                                        <div className="label">
                                            Economia com o Mercado Livre (%)
                                        </div>
                                        <div className="value">
                                            {calculateEconomy(((unitCalc as any).cativo?.totalFlag ?? 0), ((unitCalc as any).mercadoLivre?.total ?? 0))}
                                        </div>
                                    </div>
                                </div>

                                <div className="calculateBox">
                                    <Cative data={(unitCalc as any)?.data} calc={(unitCalc as any)?.cativo} />
                                    <hr />
                                    <MercadoLivre data={(unitCalc as any)?.data} calc={(unitCalc as any)?.mercadoLivre} />
                                </div>
                                        </>
                                    )
                                }
                            </div>
                        </>
                    ) : (
                        <Loading />
                    )
            }
        </Admin>
    );
}

export default Report;